import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

loadAppConfig().then(() => {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
});


function loadAppConfig(): Promise<any> {
  return fetch('assets/config.json') // 加载配置文件
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Failed to fetch config.json: ${response.statusText}`);
      }
      return response.json();
    })
    .then((config) => {
      (window as any).APP_CONFIG = config;
    })
    .catch((err) => {
      console.error('Could not load config.json:', err);
      throw err;
    });
}